/* eslint-disable no-console */
import {DivIcon, LatLngExpression} from 'leaflet';
import React from 'react';
import {Marker, Popup, useMap} from 'react-leaflet';

import PopupFlex from '../../pages/dashboard/Utils/Metrics/PopupFlex';
import FacilityPopUp from '../../pages/orgManager/Utils/FacilityAndOwner/Utils/FacilityPopUp';

import {negPosIcon, svgIcon} from './constants/commonConst';

const MarkerComp: React.FC<{type: string; mapData: any; markerRef: any[]}> = ({
  type,
  mapData,
  markerRef
}) => {
  const mapHook = useMap();

  return (
    <>
      {mapData.map((markerItem: any, index: number) => {
        const isNegative = markerItem?.emissions?.value > markerItem.benchmark;

        return (
          <Marker
            ref={(ref) => markerRef.push(ref)}
            position={markerItem.coordinates as LatLngExpression}
            autoPan={false}
            icon={
              new DivIcon({
                html: type === 'metricsMap' ? negPosIcon(isNegative) : svgIcon,
                className: 'customIcon'
              })
            }
            key={index}
            eventHandlers={{
              mouseover: (event) => {
                return event.target.openPopup();
              },
              mouseout: (event) => event.target.closePopup(),
              click: () => {
                mapHook?.flyTo(markerItem.coordinates, 12, {
                  animate: true,
                  duration: 2
                });
              }
            }}
          >
            <Popup closeButton={false}>
              {type === 'metricsMap' ? (
                <PopupFlex mapData={markerItem} isNegative={isNegative} />
              ) : (
                <FacilityPopUp mapData={markerItem} />
              )}
            </Popup>
          </Marker>
        );
      })}
    </>
  );
};

export default MarkerComp;
